import { dateToDateValue } from "@smartsuite/fields-logic/lib/utils/date";
import { parseISO } from "date-fns";
import type { FormConfig, FormConfigApplicationStructureItem } from "../../../types/form";
import type { FieldRegistryConfig } from "../../types";
import { dateToReviewString } from "../review/reviewString.helpers";
import { DateFieldControl } from "./DateFieldControl/DateFieldControl";
export interface DateFieldValue {
  date: string | null;
  include_time: boolean;
}

export const prefillDate = ({
  value,
  field,
  config,
}: {
  value: string;
  field: FormConfigApplicationStructureItem;
  config?: FormConfig;
}): {
  date: Date | null;
  include_time: boolean;
} | null => {
  const iso8601Regex =
    /^([+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([.,]\d+(?!:))?)?(\17[0-5]\d([.,]\d+)?)?([zZ]|([+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
  if (!iso8601Regex.test(value)) return null;

  const dateField = config?.form_state.items.find((item) => item.slug === field.slug);
  const includeTime = dateField?.params.include_time ?? false;

  const date = parseISO(value);

  return {
    date: isNaN(date.getTime()) ? null : date,
    include_time: includeTime,
  };
};

const convertDateToApi = (value: DateFieldValue): DateFieldValue => {
  if (!value.date) return value;

  return value.include_time
    ? {
        ...value,
        date: new Date(value.date).toISOString(),
      }
    : dateToDateValue(new Date(value.date), value.include_time);
};

export const dateFieldConfig: FieldRegistryConfig<DateFieldValue> = {
  icon: "date-select",
  control: (props) => <DateFieldControl {...props} />,
  convertFormValueToApi: convertDateToApi,
  prefill: ({ value, field, config }) => prefillDate({ value, field, config }),
  toReviewString: (value, _appField, preferences) =>
    dateToReviewString(value, preferences?.locale.time_format, preferences?.timezone?.value),
};
